import billingApiModule from '../billingApi.module';

class BillingActionApiService {
    constructor(__env, $q, apiUtil, authenticationConstants) {
        this.__env = __env;
        this.$q = $q;
        this.apiUtil = apiUtil;
        this.authenticationConstants = authenticationConstants;
    }

    getGlobalActions() {
        return this.apiUtil.getWithBearerAuth(
            this.authenticationConstants.billing.name,
            `${this.__env.billingApiUrl}/api/v1/actions`
        );
    }
}

export default billingApiModule.service(
    'billingActionApiService',
    BillingActionApiService
);



// WEBPACK FOOTER //
// ./modules/billingApi/action/billingActionApi.service.js